import React from "react";

function WomenEntryToPrisoner() {
  return (
    <div className="bg-women-entry-to-prisoner py-5">
      <div className="container">
        <div>
          <h2 className="text-h-black text-light">Upon Entering the Prison</h2>
        </div>

        <div className="row row-cols-1 row-cols-md-3 g-4 my-5">
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “As we arrived at the female barracks, there was a message
                  hand-painted on one of the walls in Urdu, emphasising the
                  importance of 'purdah' (veil) and 'haya' (modesty) for women.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">
                  - Independent study by an HR organisation
                </small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  Zahra witnessed a woman being beaten. On the day of her
                  arrival, she was beaten and, on the second day, she was made
                  to fast. Zahra asked the warden why they were beating the
                  woman; they explained she was a thief and drug addict, and was
                  being beaten and deprived of food for refusing to sweep the
                  floors.
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Author Radha Shah</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  When I asked Zahra if the children received any schooling, she
                  said they went to a classroom and were instructed by a
                  prisoner. When I visited the prison, I stumbled upon a young
                  girl play-teaching a few toddlers, and the warden
                  confidentially told me the girl was a prisoner.She couldn’t
                  have been more than 15 years-old.
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Author Radha Shah</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WomenEntryToPrisoner;
